// Frames auf dem WS-Kanal "events", die nichts Gespeichertes aendern.
//
// Jeder Aufgaben-Lauf sendet zwei Frames: task_started (steht nie in der
// events-Tabelle) und task_finished/task_failed. Seit 14.10.2026 schreibt
// der Runner einen Routine-Erfolg (Erfolg nach Erfolg) gar nicht mehr in
// die Tabelle und markiert den Frame mit gespeichert=false
// (docs/performance-2026-10.md, B5). Stores, die nur Gespeichertes zeigen
// (Meldungen, kritische Lage, Ereignisse, Verbindungszustand), holten bis
// dahin bei JEDEM dieser Frames neu -- neun Waechter im 2-Minuten-Takt
// sind ~10 Frames pro Minute.
//
// Ein Frame ohne das Feld (aelterer Server) gilt NICHT als Routine.
//
// Seit 02.11.2026 hoeren Meldungen, kritische Lage, Ereignisse und Feed nicht
// mehr auf diesem Kanal, sondern auf dem Protokoll-Topic `meldung`
// (protokoll/meldungen.svelte.ts) -- das kennt keine Routine-Laeufe. Die
// Verbindungszustaende kommen seit 02.11.2026 als Topic `link.stand` (netz.svelte.ts);
// hier bleibt tasks-summary.

export interface EventsFrame {
  domain?: string;
  type?: string;
  gespeichert?: boolean;
}

export function istRoutineFrame(data: unknown): boolean {
  const ev = data as EventsFrame | undefined;
  if (!ev || typeof ev !== "object" || ev.domain !== "tasks") return false;
  if (ev.type === "task_started") return true;
  return ev.type === "task_finished" && ev.gespeichert === false;
}
